module.exports = __webpack_public_path__ + "static/media/21ECLAC3.67ded057.jpg";